// extracted by mini-css-extract-plugin
export var body = "_l2-0";
export var sectionHeader = "_l2-4";
export var shortcutColumns = "_l2-2";
export var shortcutList = "_l2-1";
export var shortcutSection = "_l2-3";